import { Divider, Grid, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewEditGoodsItemFormValues } from '@e-origin/contracts';

import { EditArray, TextInput } from '@components';

interface GoodsItemDataProps {
  goodsItemForm: UseFormReturnType<TSDViewEditGoodsItemFormValues>;
  disabled: boolean;
}

export const GoodsItemData: React.FC<GoodsItemDataProps> = ({ goodsItemForm, disabled }) => {
  return (
    <Stack my="md">
      <Grid>
        <Grid.Col span={3}>
          <TextInput
            {...goodsItemForm.getInputProps('commodity.descriptionOfGoods')}
            label="Description of goods"
            disabled={disabled}
            data-pw="description-of-goods-input"
          />
        </Grid.Col>
        <Grid.Col span={2}>
          <TextInput
            {...goodsItemForm.getInputProps('commodity.commodityCode.harmonizedSystemSubHeadingCode')}
            label="HS code"
            disabled={disabled}
            data-pw="hs-code-input"
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <TextInput
            {...goodsItemForm.getInputProps('commodity.commodityCode.combinedNomenclatureCode')}
            label="Combined nomenclature code"
            disabled={disabled}
            data-pw="combined-nomenclature-code-input"
          />
        </Grid.Col>
        <Grid.Col span={2}>
          <TextInput {...goodsItemForm.getInputProps('commodity.cusCode')} label="CUS code" disabled={disabled} data-pw="cus-code-input" />
        </Grid.Col>
      </Grid>

      <Divider m="sm" />

      <EditArray
        addButtonLabel="Add package"
        addButtonDataPW="add-package-btn"
        form={goodsItemForm}
        inputs={[
          {
            type: 'MultiLang',
            label: 'Type of Packages',
            name: 'typeOfPackages',
            code: 'CL017',
            width: 20,
            'data-pw': 'type-of-packages-input',
          },
          {
            type: 'Input',
            label: 'Number of Packages',
            name: 'numberOfPackages',
            width: 24,
            'data-pw': 'number-of-packages-input',
          },
          {
            type: 'Input',
            label: 'Marks',
            name: 'shippingMarks',
            width: 36,
            'data-pw': 'shipping-marks-input',
          },
        ]}
        arrayPath="packaging"
        disabled={disabled}
        codelistSystemsConfig={{}}
      />

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...goodsItemForm.getInputProps('weight.grossMass')} label="Gross Mass" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
